import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M19.686 2.941c.163-.047.428-.11.702-.02.326.11.581.365.69.691.092.274.028.539-.019.702-.05.173-.133.383-.222.614l-6.188 15.855c-.1.257-.19.487-.276.662-.078.157-.218.416-.49.557a1.093 1.093 0 0 1-1.01 0c-.271-.142-.411-.401-.489-.559-.086-.174-.175-.405-.276-.662l-2.469-6.35-.02-.05a6.937 6.937 0 0 0-.05-.02l-6.35-2.47c-.258-.1-.488-.19-.662-.275-.158-.078-.417-.218-.558-.49a1.093 1.093 0 0 1 0-1.009c.14-.272.4-.412.557-.49a8.91 8.91 0 0 1 .661-.276l15.855-6.188c.23-.09.441-.172.614-.222ZM19.2 5.684l-5.705 14.62-.116.293-.115-.294-2.431-6.252L19.2 5.684Zm-9.251 7.484L18.316 4.8l-14.62 5.704-.293.116.294.115 6.252 2.431Z"
      clip-rule="evenodd"
    />
  </svg>
`;
